import request from '@/utils/request'

// 
export function addAppVersion(data) {
  return request({
    url: '/appVersion/save',
    method: 'post',
    data: data
  })
}

// 
export function delAppVersion(data) {
  return request({
    url: '/appVersion/delete',
    method: 'post',
    data: data
  })
}

// 
export function queryAppVersionList(data) {
  return request({
    url: '/appVersion/list',
    method: 'post',
    data: data
  })
}

